<template>
  <!--
        作者：gh
        时间：2025-12-12
        描述：会员-用户列表-会员编辑
    -->
  <div>
    <el-dialog
      title="会员编辑"
      :visible.sync="dialogVisible"
      @close="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div id="pdf">
        <table
          border="1px"
          cellpadding="10px"
          class="tablepdf"
          style="width: 100%"
        >
          <tr>
            <th>昵称</th>
            <td>{{ form.nickName }}</td>
          </tr>
          <tr>
            <th>真实姓名</th>
            <td>{{ form.username ? form.username : 0 }}</td>
          </tr>
          <tr>
            <th>身份证号</th>
            <td>{{ form.usernum ? form.usernum : 0 }}</td>
          </tr>
          <tr>
            <th>邮箱</th>
            <td>{{ form.email ? form.email : 0 }}</td>
          </tr>
          <tr>
            <th>紧急联系人</th>
            <td>{{ form.jinji ? form.jinji : 0 }}</td>
          </tr>
          <tr>
            <th>紧急联系人电话</th>
            <td>{{ form.jinjiphone ? form.jinjiphone : 0 }}</td>
          </tr>
          <tr>
            <th>手机号</th>
            <td>{{ form.mobile ? form.mobile : 0 }}</td>
          </tr>
          <tr>
            <th>用户头像</th>
            <td style="display: flex; justify-content: center">
              <img
                v-if="form.avatarUrl"
                style="width: 65px; height: 65px"
                :src="form.avatarUrl"
              />
              <div v-else>0</div>
            </td>
          </tr>
          <tr>
            <th>身份证正面</th>
            <td style="display: flex; justify-content: center">
              <img
                v-if="form.sfzpositive"
                style="width: 90px; height: 70px"
                :src="form.sfzpositive"
              />
              <div v-else>0</div>
            </td>
          </tr>
          <tr>
            <th>身份证反面</th>
            <td style="display: flex; justify-content: center">
              <img
                v-if="form.sfzback"
                style="width: 90px; height: 70px"
                :src="form.sfzback"
              />
              <div v-else>0</div>
            </td>
          </tr>
        </table>
      </div>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogFormVisible">取 消</el-button>
          <el-button type="primary" @click="editUser" :loading="loading">确 定</el-button> -->
        <el-button type="primary" @click="editPDF" :loading="loading"
          >导出PDF</el-button
        >
      </div>
    </el-dialog>
    <!--上传图片-->
    <Upload
      v-if="isupload"
      :isupload="isupload"
      :type="type"
      :config="{ total: 1, file_type: 'image' }"
      @returnImgs="returnImgsFunc"
    ></Upload>
  </div>
</template>
  
  <script>
import UserApi from "@/api/user.js";
import Upload from "@/components/file/Upload";
import draggable from "vuedraggable";
export default {
  components: {
    Upload,
    draggable,
  },
  data() {
    return {
      /*左边长度*/
      formLabelWidth: "120px",
      /*是否显示*/
      loading: false,
      dialogVisible: false,
      type: [],
      type1: [],
      type2: [],
      /*是否打开图片选择*/
      isupload: false,
    };
  },
  props: ["open_edit1", "form", "gradeList"],
  created() {
    this.dialogVisible = this.open_edit1;
    console.log("id", this.form.user_id);
  },
  methods: {
    // 导出pdf
    editPDF() {
      const str = document.getElementById("pdf").innerHTML;
      console.log(str);
      window.open(
        "https://shoujizulin2.rchz.top/index.php/shop/order.order/createpdf?str=" +
          str + "&name=用户信息",
        "_blank"
      );
    },
    /*选择图片*/
    chooseImg: function (file_type, file_name) {
      this.file_name = file_name;
      this.isupload = true;
    },

    /*关闭选择图片*/
    returnImgsFunc(e) {
      this.isupload = false;
      if (e != null) {
        if (this.file_name == "avatarUrl") {
          this.form.avatarUrl = e[0].file_path;
        } else if (this.file_name == "sfzpositive") {
          this.form.sfzpositive = e[0].file_path;
        } else if (this.file_name == "sfzback") {
          this.form.sfzback = e[0].file_path;
        }
      }
    },
    returnImgsFunc1(e) {
      this.isupload1 = false;
      if (e != null && e.length > 0) {
        if (this.type == "image") {
          this.form.sfzpositive = e[0].file_path;
        }
      }
    },
    returnImgsFunc2(e) {
      this.isupload2 = false;
      if (e != null && e.length > 0) {
        if (this.type == "image") {
          this.form.sfzback = e[0].file_path;
        }
      }
    },
    /*修改用户*/
    editUser() {
      let self = this;
      self.loading = true;
      let params = self.form;
      let newparams = {};

      newparams.nickName = params.nickName;
      newparams.username = params.username;
      newparams.usernum = params.usernum;
      newparams.email = params.email;
      newparams.jinji = params.jinji;
      newparams.jinjiphone = params.jinjiphone;
      newparams.mobile = params.mobile;
      newparams.avatarUrl = params.avatarUrl;
      newparams.sfzpositive = params.sfzpositive;
      newparams.sfzback = params.sfzback;

      let id = self.form.user_id;
      newparams.user_id = id;
      UserApi.edituser1(newparams, true)
        .then((data) => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: "恭喜你，用户修改成功",
              type: "success",
            });
            self.dialogFormVisible(true);
          }
        })
        .catch((error) => {
          self.loading = false;
        });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false,
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false,
        });
      }
    },
  },
};
</script>
  
  <style>
</style>
  


// WEBPACK FOOTER //
// src/views/user/user/dialog/UserView.vue